'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscoreString = require('underscore.string');

var _underscoreString2 = _interopRequireDefault(_underscoreString);

var _components = {
	_$ClosableTab: {
		displayName: 'ClosableTab'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var ClosableTab = (function (_Component) {
	_inherits(ClosableTab, _Component);

	function ClosableTab() {
		_classCallCheck(this, _ClosableTab);

		_Component.apply(this, arguments);
	}

	ClosableTab.prototype.handleClose = function handleClose(e) {
		e.preventDefault();
		e.stopPropagation();
		if (this.props.onClose) {
			this.props.onClose(this.props.id);
		}
	};

	ClosableTab.prototype.render = function render() {
		var _this = this;

		var truncated = _underscoreString2['default'].truncate(this.props.title, 26);
		return _react2['default'].createElement(
			'span',
			{ className: 'closabletab' },
			_react2['default'].createElement('i', { onClick: function (e) {
					return _this.handleClose(e);
				}, className: 'tabclose icon-cross' }),
			_react2['default'].createElement(
				'span',
				null,
				truncated,
				this.props.unsave && _react2['default'].createElement(
					'span',
					null,
					' *'
				)
			)
		);
	};

	var _ClosableTab = ClosableTab;
	ClosableTab = _wrapComponent('_$ClosableTab')(ClosableTab) || ClosableTab;
	return ClosableTab;
})(_Component2['default']);

exports['default'] = ClosableTab;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ClosableTab.js
 ** module id = 975
 ** module chunks = 2
 **/